// IE11 checks
// - https://github.com/jquery/jquery/issues/4386
if (window.document.documentMode && window.navigator.userAgent.indexOf("Trident/") > 0) {
  // Load babel backwards-compatibility extension
  //  [+] https://babeljs.io/docs/en/babel-polyfill/
  //  [!] TODO: when we update to the latest babel we should switch to core-js3 and update README
  //              \_ https://github.com/zloirock/core-js#commonjs
  //
  // Covers:
  //  ** react-dom needs Symbol (complex polyfill)
  //  ** our modules use:
  //      https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from
  //      https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_objects/Object/assign
  //
  require("babel-polyfill");
}

let Cache = require("./lib/Cache");
let Bundle = require("./lib/Bundle");
let Router = require("./lib/Router");
let Auth = require("./lib/Auth");
let Loader = require("./lib/Loader");
let Logger = require("./lib/Logger");
let PromiseLib = require("./lib/es6-promise");
let State = require("./lib/State");
let Server = require("./lib/Server");

let mc = {};
mc.Emitter = require("./lib/Emitter");
mc.ajax = require("./lib/Ajax");
mc.format = require("./lib/Format");
mc.file = require("./lib/File");
mc.math = require("./lib/Math");
mc.utils = require("./lib/Utils");
mc.state = require("./lib/State");
mc.tz = require("./lib/TimeZone");
mc.server = new Server(location.hostname, (location.search.match(/env=(test|int|qa|prod)/) || [])[1]);
mc.cache = new Cache();
mc.bundle = new Bundle();
mc.router = new Router();
mc.auth = new Auth();
mc.loader = new Loader();
mc.logger = Logger.getContext("mc");
mc.ui = require("./mc-ui");
mc.widgets = require("./mc-widgets");
mc.charts = require("./mc-charts");
mc.plot = require("./mc-plot");

if (!Array.prototype.find) {
  Array.prototype.find = function (predicate, thisArg) {
    let list = Object(this);
    let length = list.length >>> 0;
    let value;

    for (let i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }

    return undefined;
  };
}

if (!Array.prototype.findIndex) {
  Array.prototype.findIndex = function (predicate, thisArg) {
    let list = Object(this);
    let length = list.length >>> 0;
    let value;

    for (let i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return i;
      }
    }

    return -1;
  };
}

if (!Array.prototype.includes) {
  Array.prototype.includes = function (item, fromIndex) {
    return this.indexOf(item, fromIndex) > -1;
  };
}

if (!Array.prototype.fill) {
  Array.prototype.fill = function (value, start, end) {
    let O = Object(this);
    let len = O.length >>> 0;
    let relativeStart = start >> 0;
    let k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);
    let relativeEnd = end === undefined ? len : end >> 0;
    let _final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);

    while (k < _final) {
      O[k] = value;
      k++;
    }

    return O;
  };
}

if (!Object.values) {
  Object.values = function (obj) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    });
  };
}

// display environment flag if not in production mode
if (mc.server.ENV !== "prod") {
  let elem = document.getElementById("mc-env");

  if (elem) {
    elem.textContent = mc.server.ENV;
    elem.style.visibility = "visible";
  }
}

// default "page not found" behavior
mc.router.setFallback(mc.ui.fatal);

// default strings used in core package, can be overwritten
mc.bundle.addMessages({
  "loading": "Loading ...",
  "save": "Save",
  "cancel": "Cancel",
  "delete": "Delete",
  "okay": "Okay",
  "oops": "Oops!",
  "cancel_editing": "Wait! You have unsaved changes.",
  "keep_editing": "Keep Editing",
  "discard_changes": "Discard Changes",
  "drag_files_here": "Drag files here",
  "add_files": "Add files ..."
});

window.Promise = window.Promise || PromiseLib.Promise;
window.tx = mc.bundle.translate.bind(mc.bundle);
window.mc = mc;

module.exports = mc;
